import React, { useEffect } from "react";
import { Direction, IBundle, IBundleItem, IRoute, IRouteLeg, ITravelDetailsState, getApiCallState } from "../Models";
// import { getStrings } from "../../Shared/Reservation/StringResources";
import { useDispatch } from "react-redux";
import { setOptions } from "../Actions";
import { Alert, Badge, Col, Row } from "react-bootstrap";
import { Price } from "../Components/Price";
import { NumberSelector } from "../Components/NumberSelector";
import { KrogenOptions } from "./KrogenOptions";
import { isTest } from "../S3BookingApp";
import { getKrogenProductCodes } from "./KrogenOptionsHelpers";
import { getStrings } from "../../Shared/Reservation/StringResources";

// const strings = getStrings().component.selectJourney.journeyAdvice;
const optionStrings = getStrings().component.options;
const tableBookingStrings = getStrings().component.tableBooking;

export const optionGroups = {
	krogen: { productCodes: getKrogenProductCodes(), sortOrder: 1 },
	takeAway: { productCodes: ["TAB", "VTAB", "TAG", "TAG2", "TABAG"], sortOrder: 2 },
	bagage: { productCodes: ["LCI", "SCI"], sortOrder: 3 }
};

export function getOptionGroup(productCode: string)
{
	var names = Object.getOwnPropertyNames(optionGroups);
	for (let i=0; i<names.length; i++)
	{
		if (optionGroups[names[i]].productCodes?.includes(productCode))
			return names[i];
	}

	return "others";
}


export const Options = (props: { direction: Direction, travelDetails: ITravelDetailsState }) => {

	const travelState = props.travelDetails[props.direction];
	const selectedBundle = travelState.bundle;
	const selectedOptions = travelState.options || {};

	const dispatch = useDispatch();

	function optionCount(leg: IRouteLeg, opt: IBundleItem): number {
		if (!selectedOptions[leg.id] || !selectedOptions[leg.id][opt.passengerFares[0].tariffCode])
			return 0;
		return selectedOptions[leg.id][opt.passengerFares[0].tariffCode];
	}

	const optionChanged = (option: IBundleItem, count: number, legId: string) => {
		const code = option.passengerFares[0].tariffCode;
		const currentCount = !selectedOptions || !selectedOptions[legId] || !selectedOptions[legId][code] ? 0 : selectedOptions[legId][code];

		if (currentCount !== count)
			dispatch(setOptions(props.direction, code, count, legId));
	};

	//Om vi byter bundle måste vi (kanske) uppdatera options
	useEffect(() => {
		if (!selectedBundle || !selectedOptions)
			return;

		//Om någon vald option inte längre är tillgänglig måste vi nolla ut den
		Object.getOwnPropertyNames(selectedOptions).forEach(legId => {
			Object.getOwnPropertyNames(selectedOptions[legId]).forEach(code => {
				if (!selectedBundle.options?.find(x => x.legIds.includes(legId) && x.passengerFares[0].tariffCode === code))
					dispatch(setOptions(props.direction, code, 0, legId));
			});
		});
	}, [selectedBundle]);

	if (!(selectedBundle?.options?.length > 0))
		return null;

	const groupedOptions = selectedBundle?.options.reduce((acc, curr) => {
		const groupName = getOptionGroup(curr.productCode);
		const sortOrder = optionGroups[groupName] ? optionGroups[groupName].sortOrder : 100;
		let group = acc.find(x => x.name === groupName);
		if (!group)
		{
			group = { name: groupName, sortOrder, options: [] };
			acc.push(group);
		}

		group.options.push(curr);

		return acc;
	}, [] as {name: string, sortOrder: number, options: IBundleItem[]}[]).sort((a, b) => a.sortOrder - b.sortOrder);


	return <>
		{ groupedOptions.map(g => <OptionGroup key={g.name} groupName={g.name} options={g.options} route={travelState.route} getOptionCount={optionCount} onOptionChanged={optionChanged}/> )}
	</>;
};

const OptionGroup = (props: { groupName: string, options: IBundleItem[], route: IRoute, getOptionCount: (leg: IRouteLeg, option: IBundleItem) => number, onOptionChanged: (option: IBundleItem, count: number, legId: string) => void }) => {

	const bookTableState = getApiCallState().getLoadingState("bookTemporaryTable");
	const groupHeading = optionStrings.optionGroups[props.groupName] ?? props.groupName;

	if (props.groupName === "krogen")
		return <KrogenOptions options={props.options} route={props.route} getOptionCount={props.getOptionCount} onOptionChanged={props.onOptionChanged} />;

	return <section>
		<h2>{groupHeading}</h2>

		{ props.groupName === "krogen" && <Alert variant="danger" show={bookTableState === "error"}>{tableBookingStrings.errorBookingTable}</Alert> }

		{ props.route.legs.filter(leg => props.options.some(opt => opt.legIds.includes(leg.id))).map(leg => <div key={leg.id}>
			{ props.route.legs.length > 1 && <h4>{leg.departureStation.name} - {leg.arrivalStation.name}</h4> }

			<div className="option-selector">
				{ props.options.filter(opt => opt.legIds.some(x => x == leg.id)).map(opt => <React.Fragment key={opt.id}>

					<Row key={opt.id} className="mb-1">
						<Col xs={8} sm={9}><label htmlFor={`option_${opt.id}`}>{opt.name} (<Price amount={opt.passengerFares[0].price} />){isTest() && <Badge variant="light" className="ml-4">{opt.productCode}</Badge>}</label></Col>
						<Col xs={4} sm={3}><NumberSelector inputId={`option_${opt.id}`} min={0} max={opt.passengerFares.length} initialValue={props.getOptionCount(leg, opt)} onValueChanged={n => props.onOptionChanged(opt, n, leg.id)} /></Col>
					</Row>
				</React.Fragment>)}
			</div>
		</div>)}
	</section>;
};

export const optionPrice = (travel: { bundle?: IBundle, options?: { [legId: string]: { [tariffCode: string]: number }} }) => {
	if (!travel?.bundle || !travel.options)
		return 0;

	let price = 0;
	Object.getOwnPropertyNames(travel.options).forEach(legId => {
		const legOptions = travel.options[legId];
		Object.getOwnPropertyNames(legOptions).forEach(code => {
			const item = travel.bundle.options.find(x => x.legIds.includes(legId) && x.passengerFares[0].tariffCode === code);
			const count = legOptions[code];
			if (item)
				price += count * item.passengerFares[0].price; //Bygger på att alla har samma pris på tillval, men så ska det vara
		});
	});

	return price;
};